// components/MarkdownViewer.tsx
"use client";
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';

export function MarkdownViewer({ content }: { content: string }) {
  return (
    <div className="prose max-w-none dark:prose-invert p-4"> 
      <ReactMarkdown
        remarkPlugins={[remarkMath]}
        rehypePlugins={[rehypeKatex]}
      >
        {content || ""}
      </ReactMarkdown>
    </div>
  );
}